<template>
    <label class="file-select">
        <div class="select-button">
            <span v-if="value">فایل انتخابی: {{value.name}}</span>
            <span v-else>
                <v-icon>cloud_upload</v-icon>
                فایلی برگزینید </span>
            <v-progress-linear
                    color="yellow"
                    v-if="upload_icon.length === 0 && value"
                    v-model="progress"
            ></v-progress-linear>
            <div style="direction: ltr" v-if="base_image_width > 0">({{base_image_width}}px x
                {{base_image_height}}px‍)
            </div>
            <v-icon v-if="upload_icon.length > 0" color="yellow">{{upload_icon}}</v-icon>
        </div>
        <input type="file" @change="handleFileChange"/>
        <v-snackbar
                :bottom="snackbar.y === 'bottom'"
                :color="snackbar.color"
                :left="snackbar.x === 'left'"
                :multi-line="snackbar.mode === 'multi-line'"
                :right="snackbar.x === 'right'"
                :timeout="snackbar.timeout"
                :top="snackbar.y === 'top'"
                :vertical="snackbar.mode === 'vertical'"
                v-model="snackbar.snackbar"
        >
            {{ snackbar.text }}
            <v-btn @click.native="snackbar.snackbar = false" dark flat icon>
                <v-icon>close</v-icon>
            </v-btn>
        </v-snackbar>
    </label>
</template>

<script>
import HttpErrorToSnackbar from '@/api/HttpErrorToSnackbar';

export default {
  props: {
    value: File,
    url: String,
    form: Object,
    form_index: {
      type: String,
      default: 'data'
    },
  },
  data () {
    return {
      progress: 0,
      upload_icon: '',
      base_image_width: 0,
      base_image_height: 0,
      snackbar: {
        snackbar: false,
        y: 'top',
        x: 'right',
        mode: 'multi-line',
        timeout: 6000,
        color: 'error',
        text: ''
      },
    };
  },
  methods: {
    handleFileChange (e) {
      this.$emit('input', e.target.files[0]);
      if (this.url.length === 0) {
        return;
      }
      let formData = new FormData();
      if (e.target.files[0] === undefined) {
        this.snackbar.text = 'فایلی دریافت نشد!';
        this.snackbar.snackbar = true;
        this.snackbar.color = 'red';
        this.upload_icon = '';
        return;
      }

      this.base_image_width = 0;
      this.base_image_height = 0;

      let reader = new FileReader();
      reader.onload = (event) => {
        let img = new Image();
        img.onload = () => {
          this.base_image_width = img.width;
          this.base_image_height = img.height;

          if (typeof this.form === 'object') {
            let data = Object.assign({}, this.form);
            data.keywords = data.keywords.join(',');
            data.bg_color = data.bg_color.r + ',' + data.bg_color.g + ',' + data.bg_color.b + ',' + data.bg_color.a;

            formData.append(this.form_index, JSON.stringify(data));
          }
          formData.append('file', e.target.files[0]);
          this.Upload(formData);
        };
        img.src = event.target.result;
      };
      reader.onerror = () => {
        this.snackbar.text = 'فایل موردنظر قابل پردازش نمیباشد!';
        this.snackbar.snackbar = true;
        this.snackbar.color = 'red';
      };
      reader.readAsDataURL(e.target.files[0]);
    },
    Upload (formData) {
      if (this.base_image_width === 0) {
        this.snackbar.text = 'فایل موردنظر قابل پردازش نمیباشد!';
        this.snackbar.snackbar = true;
        this.snackbar.color = 'red';
        return;
      }
      this.axios.post(this.url + '?w=' + this.base_image_width + '&h=' + this.base_image_height,
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          onUploadProgress: function (progressEvent) {
            this.upload_icon = '';
            this.progress = parseInt(Math.round((progressEvent.loaded * 100) / progressEvent.total), 10);
          }.bind(this)
        }
      ).then((response) => {
        this.upload_icon = 'done_all';
        this.$emit('done', response.data);
      }).catch(error => {
        this.snackbar = HttpErrorToSnackbar(error);
      });
    }
  }
};
</script>

<style scoped>
    .file-select > .select-button {
        padding: 1rem;
        cursor: pointer;
        color: #7e7e7e;
        border: 1px dashed #393836;
        border-radius: .3rem;
        text-align: center;
        font-weight: bold;
    }

    .file-select > input[type="file"] {
        display: none;
    }
</style>



// WEBPACK FOOTER //
// src/components/FileSelect.vue